export default __webpack_public_path__ + "static/media/tick.e60e0257.svg";